/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const NotificationIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 11.6428V9.07141C18 7.48011 17.3678 5.95399 16.2426 4.82877C15.1174 3.70355 13.5913 3.07141 12 3.07141C10.4087 3.07141 8.88256 3.70355 7.75735 4.82877C6.63213 5.95399 5.99999 7.48011 5.99999 9.07141V11.6428C5.99999 14.4714 3.42856 15.1571 3.42856 16.7857C3.42856 18.2428 6.77142 19.3571 12 19.3571C17.2286 19.3571 20.5714 18.2428 20.5714 16.7857C20.5714 15.1571 18 14.4714 18 11.6428Z"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M12 21.0714C11.1334 21.0714 10.3191 21.0423 9.55286 20.9857C9.71622 21.5068 10.0417 21.9622 10.4818 22.2855C10.922 22.6088 11.4539 22.7831 12 22.7831C12.5461 22.7831 13.078 22.6088 13.5182 22.2855C13.9583 21.9622 14.2838 21.5068 14.4471 20.9857C13.6809 21.0423 12.8666 21.0714 12 21.0714Z"
        fill={color}
      />
    </svg>
  );
};
